import { IIconSetMap, iconSetNames as sets } from '../icon-set/IconSet';
import names from './iconNames';

import downArrow from './_default/arrowDownIcon.inline.svg';

const iconSetMap: IIconSetMap = {
    [names.downArrowIcon]: {
        [sets.wide]: downArrow,
        [sets.narrow]: null
    }
};

export default iconSetMap;
